import { TemplateChooser } from "@containers/verification-service-details/verification-service-details-tab-container/verification-service-details-theming-tab/theming-messaging-tab-container/template-chooser-list/template-chooser/template-chooser";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import { SelectOption } from "@iddataweb/idw-common-ui/types";
import { ThemingMessagingTemplateValidationWarnings } from "@idw-types/common/validation/common/theming-validation-errors";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";

type TemplateChooserListProps = {
    isDisabled: boolean;
    messagingTemplatePerTypeOptions: { [key: string]: Array<SelectOption<any>> };
    availableMessagingTemplateTypeOptions: Array<SelectOption<MessagingTemplateTypes>>;
    templateTypeRequestInProgressMap: { [messagingTemplateType: string]: boolean };
    selectedMessagingTemplates: Array<FormattedMessagingTemplate>;
    setSelectedTemplate: (selectOption: SelectOption<MessagingTemplateTypes>, messagingTemplateType: MessagingTemplateTypes) => void;
    validationWarnings: ThemingMessagingTemplateValidationWarnings;
}

export const TemplateChooserList = (props: TemplateChooserListProps) => {
    const {
        isDisabled,
        availableMessagingTemplateTypeOptions,
        messagingTemplatePerTypeOptions,
        templateTypeRequestInProgressMap,
        selectedMessagingTemplates,
        validationWarnings,
        setSelectedTemplate
    } = props;

    return (
        <>
            {availableMessagingTemplateTypeOptions.map((option) => {
                return <div key={option.value}>
                    <TemplateChooser
                        templateOptions={messagingTemplatePerTypeOptions[option.value]}
                        isDisabled={isDisabled}
                        index={option.value}
                        messagingTemplateType={option.value}
                        templateRequestInProgress={templateTypeRequestInProgressMap[option.value]}
                        selectedMessagingTemplates={selectedMessagingTemplates}
                        validationWarning={validationWarnings[option.value]}
                        setSelectedTemplate={setSelectedTemplate}
                    />
                </div>
            })}
        </>
    );
}